import { createFeatureSelector } from '@ngrx/store';
import { panelFeatureKey } from '@stores/panel/panel.reducer';

const selectPanel = createFeatureSelector<boolean>(panelFeatureKey);

export { selectPanel as isBurgerOpen };
